import { render, staticRenderFns } from "./CampaignMemoDialog.vue?vue&type=template&id=16e3411e&scoped=true"
import script from "./CampaignMemoDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./CampaignMemoDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CampaignMemoDialog.vue?vue&type=style&index=0&id=16e3411e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e3411e",
  null
  
)

export default component.exports